export const DEFAULT_STYLES = {
  chart: {
    labels: {
      show: true,
      color: '#000',
      fontSize: 16,
    },
    border: {
      show: true,
      color: '#FFF',
      width: 1,
    },
    shadow: {
      show: false,
      offset: 4,
      color: '#BCB3B3',
      blurred: 4,
    },
  },
  legend: {
    labels: {
      show: true,
      color: '#000',
      fontSize: 16,
    },
    border: {
      show: false,
      color: '#BCB3B3',
      width: 4,
    },
    others: {
      outOfRangeColor: '#d9d9d9',
    },
  },
}
